<template>
	<div class='pest-core'>
		<div class='pest-core-detection-block-outer'>
			<CoreDetection/>
		</div>

		<div v-if='freqPestList.length || freqDiseaseList.length' class='grid select-value-block'>
			<div :class='{ "not-match": !isMatch(values["pest_core_number"]) }'>
				<span class='select-title'>Номер очага</span>
				<input
					v-model='values["pest_core_number"].value'
					:disabled='!actLpoIsDraft'
					class='custom-input'
				>
			</div>

			<div :class='{ "not-match": !isMatch(values["pest_core_type"]) }'>
				<span class='select-title'>Тип очага</span>
				<custom-p-select
					v-model='values["pest_core_type"].value'
					:options='info_pest_core_type'
					:disabled='!actLpoIsDraft'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["pest_core_phase"]) }'>
				<span class='select-title'>Фаза очага</span>
				<custom-p-select
					v-model='values["pest_core_phase"].value'
					:options='info_pest_core_phase'
					:disabled='!actLpoIsDraft'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_pest_core_hazard"]) }'>
				<custom-p-checkbox
					v-model='values["is_pest_core_hazard"].value'
					label='Угроза возникновения очагов'
					:disabled='!actLpoIsDraft'
				/>
			</div>
		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import CoreDetection from './CurrentLpo__pestCoreDetection';

	export default {
		name: 'InspectionPestCore',
		components: {
			CoreDetection
		},
		data() {
			return {

				values: {
					is_pest_core_hazard: {
						field: 'is_pest_core_hazard',
						inputType: 'checkbox',
						value: false
					},

					pest_core_number: {
						field: 'pest_core_number',
						inputType: 'input',
						value: null,
					},

					pest_core_type: {
						field: 'pest_core_type_id',
						inputType: 'select',
						value: null,
						catalog: 'info_pest_core_type'
					},

					pest_core_phase: {
						field: 'pest_core_phase_id',
						inputType: 'select',
						value: null,
						catalog: 'info_pest_core_phase'
					}

				},

				catalogsAreLoading: false
			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			...mapState({
				lpo: state => state.selectedLpo.lpo,
				info_pest_core_type: state => state.catalogs['info_pest_core_type'],
				info_pest_core_phase: state => state.catalogs['info_pest_core_phase']
			}),

			...mapState('selectedLpo',{
				freqDiseaseList: state => state.freqDiseaseList,
				freqPestList: state => state.freqPestList,
			}),
		},
		methods: {
			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
					};
					valueList.push(temp);
				}

				// console.log('******');
				// console.log(JSON.stringify(valueList, null, 2));
				// return;

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},

			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't');
				} else if (value.inputType === 'input') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},

		created() {
			const catalogs = [
				'info_pest_core_type',
				'info_pest_core_phase'
			];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

	
</style>